import { Box, Grid, TypographyProps } from "@mui/material";
import MultiSpecialty from "../../../../components/MultiSpecialty";
import OutlineCard from "../../../../components/OutlineCard";
import ProfileViewer from "../../../../components/ProfileViewer";
import Text from "../../../../components/Text";
import { STATE_RECORD } from "../../../../constants";
import { ProviderLocation } from "../../../../constants/ProviderLocationFromInitialValues";
import {
  DEFAULT_PROVIDER_GROUP_IMG_SRC,
  transformOfficeHoursToView,
} from "../../../../utils/utils";

const LocationDetails = ({
  locationProfile,
}: {
  locationProfile?: ProviderLocation & { groupNpiNumber?: string };
}) => {
  return (
    <Box>
      <Grid container columnSpacing={2}>
        <Grid item md={3.5} xs={12}>
          <Box mb={"16px"}>
            <OutlineCard>
              <Box
                sx={{
                  marginTop: "20px",
                  width: "100%",
                  minHeight: "320px",
                  paddingBottom: "20px",
                }}
              >
                <Box sx={{ padding: "0", marginBottom: "20px" }}>
                  <img
                    style={{ borderRadius: 5 }}
                    width={"146px"}
                    height={"130px"}
                    src={
                      locationProfile?.avatar ?? DEFAULT_PROVIDER_GROUP_IMG_SRC
                    }
                  />
                </Box>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <StyledKey>Location ID</StyledKey>
                  </Grid>
                  <Grid item xs={6}>
                    <Text>{locationProfile?.locationId ?? "-"}</Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <StyledKey>Location Name</StyledKey>
                  </Grid>
                  <Grid item xs={6}>
                    <Text>{locationProfile?.name ?? "-"}</Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <StyledKey>Work Phone</StyledKey>
                  </Grid>
                  <Grid item xs={6}>
                    <Text>
                      {!!locationProfile?.contact
                        ? locationProfile?.contact
                        : "-"}
                    </Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <StyledKey>Email</StyledKey>
                  </Grid>
                  <Grid item xs={6}>
                    <Text sx={{ overflowWrap: "break-word" }}>
                      {locationProfile?.email ?? "-"}
                    </Text>
                  </Grid>
                </Grid>
              </Box>
            </OutlineCard>
          </Box>
        </Grid>
        <Grid item md={8.5} xs={12} mb={"16px"}>
          <OutlineCard sx={{ height: "100%" }}>
            <Text variant="h4" fontWeight={"medium"}>
              Basic Information
            </Text>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <StyledKey>Speciality</StyledKey>
                  </Grid>
                  <Grid item xs={6}>
                    <Text>
                      <MultiSpecialty
                        specialties={locationProfile?.specialities}
                        width={280}
                      />
                    </Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <StyledKey>Fax Number</StyledKey>
                  </Grid>
                  <Grid item xs={6}>
                    <Text>
                      {!!locationProfile?.fax ? locationProfile?.fax : "-"}
                    </Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={6}>
                    <StyledKey>Group NPI Number</StyledKey>
                  </Grid>
                  <Grid item xs={6}>
                    <Text>{locationProfile?.groupNpiNumber ?? ""}</Text>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} mt={2}>
                <ProfileViewer
                  firstColW={3.5}
                  gap={"16px"}
                  // height={"20rem"}
                  secondColW={8}
                  withoutColn
                  data={{
                    "Office Hours":
                      transformOfficeHoursToView(
                        locationProfile?.officeHours as any
                      ) ?? "",
                  }}
                />
              </Grid>
            </Grid>
          </OutlineCard>
        </Grid>
      </Grid>
      <Box mb={"16px"}>
        <OutlineCard>
          <Box
            sx={{
              marginTop: "20px",
              width: "100%",
              paddingBottom: "20px",
            }}
          >
            <Text variant="h4" fontWeight={"medium"}>
              Practice Address
            </Text>
            <Grid container>
              <Grid item xs={8}>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>Address Line 1</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>
                      {locationProfile?.physicalAddress?.line1 ?? "-"}
                    </Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>Address Line 2</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>
                      {locationProfile?.physicalAddress?.line2 ?? "-"}
                    </Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>Country</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>
                      {locationProfile?.physicalAddress?.country ?? "-"}
                    </Text>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>State</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>
                      {locationProfile?.physicalAddress?.state
                        ? STATE_RECORD[
                            locationProfile?.physicalAddress?.state as any
                          ]
                        : "-"}
                    </Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>City</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>{locationProfile?.physicalAddress?.city ?? "-"}</Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>ZIP Code</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>
                      {locationProfile?.physicalAddress?.zipcode ?? "-"}
                    </Text>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </OutlineCard>
      </Box>
      <Box mb={"10px"}>
        <OutlineCard>
          <Box
            mt={"20px"}
            mr={"10px"}
            sx={{
              marginTop: "20px",
              width: "100%",
              paddingBottom: "20px",
            }}
          >
            <Text variant="h4" fontWeight={"medium"}>
              Pay To (Billing) Address
            </Text>
            <Grid container>
              <Grid item xs={8}>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>Address Line 1</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>{locationProfile?.billingAddress?.line1 ?? "-"}</Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>Address Line 2</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>{locationProfile?.billingAddress?.line2 ?? "-"}</Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>Country</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>
                      {locationProfile?.billingAddress?.country ?? "-"}
                    </Text>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={4}>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>State</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>
                      {locationProfile?.billingAddress?.state
                        ? STATE_RECORD[
                            locationProfile?.billingAddress?.state as any
                          ]
                        : "-"}
                    </Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>City</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>{locationProfile?.billingAddress?.city ?? "-"}</Text>
                  </Grid>
                </Grid>
                <Grid container mt={2}>
                  <Grid item xs={3}>
                    <StyledKey>ZIP Code</StyledKey>
                  </Grid>
                  <Grid item xs={9}>
                    <Text>
                      {locationProfile?.billingAddress?.zipcode ?? "-"}
                    </Text>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </OutlineCard>
      </Box>
    </Box>
  );
};

export default LocationDetails;

const StyledKey = ({
  children,
  ...others
}: { children: string } & TypographyProps) => (
  <Text color={"#1A1A1A80"} fontWeight={"medium"} {...others}>
    {children}
  </Text>
);
